import { render } from "./CategoryMain.vue?vue&type=template&id=6797f75c&scoped=true"
import script from "./CategoryMain.vue?vue&type=script&lang=js"
export * from "./CategoryMain.vue?vue&type=script&lang=js"

import "./CategoryMain.vue?vue&type=style&index=0&id=6797f75c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6797f75c"]])

export default __exports__